export const QueryConstants = {
    REDIRECT_TO: 'redirect_to',
    SHOW_POPUP: 'ShowPopup',
    JOIN_ONE_CLUB: 'joinOneClub',
    REDIRECT_URL: 'redirectUrl',
};
